import { Location } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/finally';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../core/components';
import { SiteModel } from '../../models';
import { modalSmall, modalLarge } from '../../shared/modules/dialogOptions'
import { AccountService, SiteService } from '../../services';

@Component({
    selector: 'app-sites-edit',
    templateUrl: './sites-edit.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class SitesEditComponent extends BaseComponent implements OnInit {
    @Output() siteListView = new EventEmitter();
    public siteModel: any = new SiteModel();
    public accountId: any;
    public accountsList: any;
    public hideAccountSelect: boolean = true;
    public showSpinner: boolean = false;

    public objLbl: string = 'Object';
    dataToDelete: any;
    public objectConfirm: any; // todo: not implemented

    constructor(
        private siteService: SiteService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private router: Router,
        public activeModal: NgbActiveModal, private modalService: NgbModal,
        private location: Location) {
        super(router);
    }
    public siteId: any;
    public ngOnInit() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'))
        this.siteModel = new SiteModel();
        this.siteModel.CompanyLogoBase64 = "/assets/images/upload-empty.png";
        this.siteModel.AccountId = currentUser.accountId;
        //should not be used anymore
        // this.route.params.subscribe((params) => {
        //     if (params) {
        //         const accountId = params['account'];
        //         this.accountId = accountId;
        //         this.siteModel.AccountId = accountId;
        //         const id = params['id'];
        //         if(id)
        //         {
        //             this.loadData(id);
        //         }
        //     }
        // });
        this.setDefaults(this.siteId);
    }

    public setDefaults(siteId?: number) {
        this.siteModel = new SiteModel();
        if (siteId) {
            this.loadData(siteId);
        }
    }
    public loadData(id?: number) {
        this.showSpinner = true;
        this.siteService.getSite(id)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {
                if (response.Data) {
                    this.siteModel = response.Data;
                }
            });
    }

    public saveChanges() {
        this.showSpinner = true;
        this.siteService.saveSite(this.siteModel)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {
                //this.toastr.success(response.Message, "Success"); 
                this.ngOnInit();
                this.closeSiteListView();
            });
    }
    public deleteObject(model: any) {
        this.siteService.deleteSite(model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: any) => {

                this.activeModal.close(); // this.DeleteObjectEventData.emit();
            });
    }
    public openDelete(title: string) {
        //this.objectConfirm = "";
        this.dataToDelete = this.siteModel;
        console.log(this.dataToDelete);
        this.modalService.open(title, modalSmall);
    }
    public onIsActiveChange(value: boolean) {
        this.siteModel.IsActive = value;
    }

    public onIsDeletedChange(value: boolean) {
        this.siteModel.IsDeleted = value;
    }

    public closeSiteListView() {
        this.activeModal.close();
        //   this.siteListView.emit();
    }

    public fileChange(fileInput: any) {

        let self = this;
        let file = <File>fileInput.target.files[0];
        if (file.size > 2000000) {
            return false;
        }
        var reader = new FileReader();
        reader.onload = function() {
            self.siteModel.CompanyLogoBase64 = reader.result;

        };
        reader.onerror = function(error) {
            console.log('Error: ', error);
        };

        reader.readAsDataURL(file);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/sites/sites-edit.component.ts